/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as BlockRouteRouteImport } from './routes/block/route'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as BlockIndexRouteImport } from './routes/block/index'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AppSettingsRouteRouteImport } from './routes/_app/settings/route'
import { Route as AppReportRouteRouteImport } from './routes/_app/report/route'
import { Route as AppProfileRouteRouteImport } from './routes/_app/profile/route'
import { Route as AppProductRouteRouteImport } from './routes/_app/product/route'
import { Route as AppOutletRouteRouteImport } from './routes/_app/outlet/route'
import { Route as AppMokaRouteRouteImport } from './routes/_app/moka/route'
import { Route as AppInventoryRouteRouteImport } from './routes/_app/inventory/route'
import { Route as AppDesignRouteRouteImport } from './routes/_app/design/route'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppReportIndexRouteImport } from './routes/_app/report/index'
import { Route as AppProfileIndexRouteImport } from './routes/_app/profile/index'
import { Route as AppProductIndexRouteImport } from './routes/_app/product/index'
import { Route as AppOutletIndexRouteImport } from './routes/_app/outlet/index'
import { Route as AppMokaIndexRouteImport } from './routes/_app/moka/index'
import { Route as AppInventoryIndexRouteImport } from './routes/_app/inventory/index'
import { Route as AppFinanceIndexRouteImport } from './routes/_app/finance/index'
import { Route as AppDesignIndexRouteImport } from './routes/_app/design/index'
import { Route as AppReportJournalRouteImport } from './routes/_app/report/journal'
import { Route as AppReportIncomeStatementRouteImport } from './routes/_app/report/income-statement'
import { Route as AppReportCashFlowRouteImport } from './routes/_app/report/cash-flow'
import { Route as AppReportBalanceSheetRouteImport } from './routes/_app/report/balance-sheet'
import { Route as AppProductCreateRouteImport } from './routes/_app/product/create'
import { Route as AppSettingsUserRouteRouteImport } from './routes/_app/settings/user/route'
import { Route as AppSettingsOutletRouteRouteImport } from './routes/_app/settings/outlet/route'
import { Route as AppProductCategoryRouteRouteImport } from './routes/_app/product/category/route'
import { Route as AppOutletStaffRouteRouteImport } from './routes/_app/outlet/staff/route'
import { Route as AppOutletDeviceRouteRouteImport } from './routes/_app/outlet/device/route'
import { Route as AppInventoryUomRouteRouteImport } from './routes/_app/inventory/uom/route'
import { Route as AppInventoryRecipeRouteRouteImport } from './routes/_app/inventory/recipe/route'
import { Route as AppInventoryPoRouteRouteImport } from './routes/_app/inventory/po/route'
import { Route as AppInventoryMasterRouteRouteImport } from './routes/_app/inventory/master/route'
import { Route as AppInventoryCategoryRouteRouteImport } from './routes/_app/inventory/category/route'
import { Route as AppSettingsUserIndexRouteImport } from './routes/_app/settings/user/index'
import { Route as AppSettingsOutletIndexRouteImport } from './routes/_app/settings/outlet/index'
import { Route as AppProductCategoryIndexRouteImport } from './routes/_app/product/category/index'
import { Route as AppOutletStaffIndexRouteImport } from './routes/_app/outlet/staff/index'
import { Route as AppOutletDeviceIndexRouteImport } from './routes/_app/outlet/device/index'
import { Route as AppInventoryUomIndexRouteImport } from './routes/_app/inventory/uom/index'
import { Route as AppInventoryRecipeIndexRouteImport } from './routes/_app/inventory/recipe/index'
import { Route as AppInventoryPoIndexRouteImport } from './routes/_app/inventory/po/index'
import { Route as AppInventoryOutletIndexRouteImport } from './routes/_app/inventory/outlet/index'
import { Route as AppInventoryMasterIndexRouteImport } from './routes/_app/inventory/master/index'
import { Route as AppInventoryCategoryIndexRouteImport } from './routes/_app/inventory/category/index'
import { Route as AppSettingsUserCreateRouteImport } from './routes/_app/settings/user/create'
import { Route as AppSettingsOutletCreateRouteImport } from './routes/_app/settings/outlet/create'
import { Route as AppSettingsOutletIdRouteImport } from './routes/_app/settings/outlet/$id'
import { Route as AppProductCategoryCreateRouteImport } from './routes/_app/product/category/create'
import { Route as AppProductIdUpdateRouteImport } from './routes/_app/product/$id.update'
import { Route as AppOutletDeviceCreateRouteImport } from './routes/_app/outlet/device/create'
import { Route as AppInventoryUomCreateRouteImport } from './routes/_app/inventory/uom/create'
import { Route as AppInventoryPoCreateRouteImport } from './routes/_app/inventory/po/create'
import { Route as AppInventoryMasterCreateRouteImport } from './routes/_app/inventory/master/create'
import { Route as AppInventoryCategoryCreateRouteImport } from './routes/_app/inventory/category/create'
import { Route as AppInventoryPoIdIndexRouteImport } from './routes/_app/inventory/po/$id.index'
import { Route as AppSettingsUserIdEditRouteImport } from './routes/_app/settings/user/$id.edit'
import { Route as AppProductCategoryIdUpdateRouteImport } from './routes/_app/product/category/$id.update'
import { Route as AppOutletDeviceIdUpdateRouteImport } from './routes/_app/outlet/device/$id.update'
import { Route as AppInventoryPoIdUpdateRouteImport } from './routes/_app/inventory/po/$id.update'
import { Route as AppInventoryMasterIdUpdateRouteImport } from './routes/_app/inventory/master/$id.update'
import { Route as AppInventoryCategoryUpdateIdRouteImport } from './routes/_app/inventory/category/update.$id'
import { Route as AppInventoryUomUpdateIdRouteImport } from './routes/_app/inventory/uom/update.$id.'

const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const BlockRouteRoute = BlockRouteRouteImport.update({
  id: '/block',
  path: '/block',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const BlockIndexRoute = BlockIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BlockRouteRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppReportRouteRoute = AppReportRouteRouteImport.update({
  id: '/report',
  path: '/report',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProfileRouteRoute = AppProfileRouteRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProductRouteRoute = AppProductRouteRouteImport.update({
  id: '/product',
  path: '/product',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOutletRouteRoute = AppOutletRouteRouteImport.update({
  id: '/outlet',
  path: '/outlet',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMokaRouteRoute = AppMokaRouteRouteImport.update({
  id: '/moka',
  path: '/moka',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppInventoryRouteRoute = AppInventoryRouteRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDesignRouteRoute = AppDesignRouteRouteImport.update({
  id: '/design',
  path: '/design',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppReportIndexRoute = AppReportIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppReportRouteRoute,
} as any)
const AppProfileIndexRoute = AppProfileIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppProfileRouteRoute,
} as any)
const AppProductIndexRoute = AppProductIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppProductRouteRoute,
} as any)
const AppOutletIndexRoute = AppOutletIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOutletRouteRoute,
} as any)
const AppMokaIndexRoute = AppMokaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppMokaRouteRoute,
} as any)
const AppInventoryIndexRoute = AppInventoryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppInventoryRouteRoute,
} as any)
const AppFinanceIndexRoute = AppFinanceIndexRouteImport.update({
  id: '/finance/',
  path: '/finance/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDesignIndexRoute = AppDesignIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDesignRouteRoute,
} as any)
const AppReportJournalRoute = AppReportJournalRouteImport.update({
  id: '/journal',
  path: '/journal',
  getParentRoute: () => AppReportRouteRoute,
} as any)
const AppReportIncomeStatementRoute =
  AppReportIncomeStatementRouteImport.update({
    id: '/income-statement',
    path: '/income-statement',
    getParentRoute: () => AppReportRouteRoute,
  } as any)
const AppReportCashFlowRoute = AppReportCashFlowRouteImport.update({
  id: '/cash-flow',
  path: '/cash-flow',
  getParentRoute: () => AppReportRouteRoute,
} as any)
const AppReportBalanceSheetRoute = AppReportBalanceSheetRouteImport.update({
  id: '/balance-sheet',
  path: '/balance-sheet',
  getParentRoute: () => AppReportRouteRoute,
} as any)
const AppProductCreateRoute = AppProductCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppProductRouteRoute,
} as any)
const AppSettingsUserRouteRoute = AppSettingsUserRouteRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsOutletRouteRoute = AppSettingsOutletRouteRouteImport.update({
  id: '/outlet',
  path: '/outlet',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppProductCategoryRouteRoute = AppProductCategoryRouteRouteImport.update({
  id: '/category',
  path: '/category',
  getParentRoute: () => AppProductRouteRoute,
} as any)
const AppOutletStaffRouteRoute = AppOutletStaffRouteRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AppOutletRouteRoute,
} as any)
const AppOutletDeviceRouteRoute = AppOutletDeviceRouteRouteImport.update({
  id: '/device',
  path: '/device',
  getParentRoute: () => AppOutletRouteRoute,
} as any)
const AppInventoryUomRouteRoute = AppInventoryUomRouteRouteImport.update({
  id: '/uom',
  path: '/uom',
  getParentRoute: () => AppInventoryRouteRoute,
} as any)
const AppInventoryRecipeRouteRoute = AppInventoryRecipeRouteRouteImport.update({
  id: '/recipe',
  path: '/recipe',
  getParentRoute: () => AppInventoryRouteRoute,
} as any)
const AppInventoryPoRouteRoute = AppInventoryPoRouteRouteImport.update({
  id: '/po',
  path: '/po',
  getParentRoute: () => AppInventoryRouteRoute,
} as any)
const AppInventoryMasterRouteRoute = AppInventoryMasterRouteRouteImport.update({
  id: '/master',
  path: '/master',
  getParentRoute: () => AppInventoryRouteRoute,
} as any)
const AppInventoryCategoryRouteRoute =
  AppInventoryCategoryRouteRouteImport.update({
    id: '/category',
    path: '/category',
    getParentRoute: () => AppInventoryRouteRoute,
  } as any)
const AppSettingsUserIndexRoute = AppSettingsUserIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsUserRouteRoute,
} as any)
const AppSettingsOutletIndexRoute = AppSettingsOutletIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsOutletRouteRoute,
} as any)
const AppProductCategoryIndexRoute = AppProductCategoryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppProductCategoryRouteRoute,
} as any)
const AppOutletStaffIndexRoute = AppOutletStaffIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOutletStaffRouteRoute,
} as any)
const AppOutletDeviceIndexRoute = AppOutletDeviceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOutletDeviceRouteRoute,
} as any)
const AppInventoryUomIndexRoute = AppInventoryUomIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppInventoryUomRouteRoute,
} as any)
const AppInventoryRecipeIndexRoute = AppInventoryRecipeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppInventoryRecipeRouteRoute,
} as any)
const AppInventoryPoIndexRoute = AppInventoryPoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppInventoryPoRouteRoute,
} as any)
const AppInventoryOutletIndexRoute = AppInventoryOutletIndexRouteImport.update({
  id: '/outlet/',
  path: '/outlet/',
  getParentRoute: () => AppInventoryRouteRoute,
} as any)
const AppInventoryMasterIndexRoute = AppInventoryMasterIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppInventoryMasterRouteRoute,
} as any)
const AppInventoryCategoryIndexRoute =
  AppInventoryCategoryIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppInventoryCategoryRouteRoute,
  } as any)
const AppSettingsUserCreateRoute = AppSettingsUserCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppSettingsUserRouteRoute,
} as any)
const AppSettingsOutletCreateRoute = AppSettingsOutletCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppSettingsOutletRouteRoute,
} as any)
const AppSettingsOutletIdRoute = AppSettingsOutletIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppSettingsOutletRouteRoute,
} as any)
const AppProductCategoryCreateRoute =
  AppProductCategoryCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppProductCategoryRouteRoute,
  } as any)
const AppProductIdUpdateRoute = AppProductIdUpdateRouteImport.update({
  id: '/$id/update',
  path: '/$id/update',
  getParentRoute: () => AppProductRouteRoute,
} as any)
const AppOutletDeviceCreateRoute = AppOutletDeviceCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppOutletDeviceRouteRoute,
} as any)
const AppInventoryUomCreateRoute = AppInventoryUomCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppInventoryUomRouteRoute,
} as any)
const AppInventoryPoCreateRoute = AppInventoryPoCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AppInventoryPoRouteRoute,
} as any)
const AppInventoryMasterCreateRoute =
  AppInventoryMasterCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppInventoryMasterRouteRoute,
  } as any)
const AppInventoryCategoryCreateRoute =
  AppInventoryCategoryCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppInventoryCategoryRouteRoute,
  } as any)
const AppInventoryPoIdIndexRoute = AppInventoryPoIdIndexRouteImport.update({
  id: '/$id/',
  path: '/$id/',
  getParentRoute: () => AppInventoryPoRouteRoute,
} as any)
const AppSettingsUserIdEditRoute = AppSettingsUserIdEditRouteImport.update({
  id: '/$id/edit',
  path: '/$id/edit',
  getParentRoute: () => AppSettingsUserRouteRoute,
} as any)
const AppProductCategoryIdUpdateRoute =
  AppProductCategoryIdUpdateRouteImport.update({
    id: '/$id/update',
    path: '/$id/update',
    getParentRoute: () => AppProductCategoryRouteRoute,
  } as any)
const AppOutletDeviceIdUpdateRoute = AppOutletDeviceIdUpdateRouteImport.update({
  id: '/$id/update',
  path: '/$id/update',
  getParentRoute: () => AppOutletDeviceRouteRoute,
} as any)
const AppInventoryPoIdUpdateRoute = AppInventoryPoIdUpdateRouteImport.update({
  id: '/$id/update',
  path: '/$id/update',
  getParentRoute: () => AppInventoryPoRouteRoute,
} as any)
const AppInventoryMasterIdUpdateRoute =
  AppInventoryMasterIdUpdateRouteImport.update({
    id: '/$id/update',
    path: '/$id/update',
    getParentRoute: () => AppInventoryMasterRouteRoute,
  } as any)
const AppInventoryCategoryUpdateIdRoute =
  AppInventoryCategoryUpdateIdRouteImport.update({
    id: '/update/$id',
    path: '/update/$id',
    getParentRoute: () => AppInventoryCategoryRouteRoute,
  } as any)
const AppInventoryUomUpdateIdRoute = AppInventoryUomUpdateIdRouteImport.update({
  id: '/update/$id/',
  path: '/update/$id/',
  getParentRoute: () => AppInventoryUomRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/auth': typeof AuthRouteRouteWithChildren
  '/block': typeof BlockRouteRouteWithChildren
  '/logout': typeof LogoutRoute
  '/design': typeof AppDesignRouteRouteWithChildren
  '/inventory': typeof AppInventoryRouteRouteWithChildren
  '/moka': typeof AppMokaRouteRouteWithChildren
  '/outlet': typeof AppOutletRouteRouteWithChildren
  '/product': typeof AppProductRouteRouteWithChildren
  '/profile': typeof AppProfileRouteRouteWithChildren
  '/report': typeof AppReportRouteRouteWithChildren
  '/settings': typeof AppSettingsRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/': typeof AppIndexRoute
  '/block/': typeof BlockIndexRoute
  '/inventory/category': typeof AppInventoryCategoryRouteRouteWithChildren
  '/inventory/master': typeof AppInventoryMasterRouteRouteWithChildren
  '/inventory/po': typeof AppInventoryPoRouteRouteWithChildren
  '/inventory/recipe': typeof AppInventoryRecipeRouteRouteWithChildren
  '/inventory/uom': typeof AppInventoryUomRouteRouteWithChildren
  '/outlet/device': typeof AppOutletDeviceRouteRouteWithChildren
  '/outlet/staff': typeof AppOutletStaffRouteRouteWithChildren
  '/product/category': typeof AppProductCategoryRouteRouteWithChildren
  '/settings/outlet': typeof AppSettingsOutletRouteRouteWithChildren
  '/settings/user': typeof AppSettingsUserRouteRouteWithChildren
  '/product/create': typeof AppProductCreateRoute
  '/report/balance-sheet': typeof AppReportBalanceSheetRoute
  '/report/cash-flow': typeof AppReportCashFlowRoute
  '/report/income-statement': typeof AppReportIncomeStatementRoute
  '/report/journal': typeof AppReportJournalRoute
  '/design/': typeof AppDesignIndexRoute
  '/finance': typeof AppFinanceIndexRoute
  '/inventory/': typeof AppInventoryIndexRoute
  '/moka/': typeof AppMokaIndexRoute
  '/outlet/': typeof AppOutletIndexRoute
  '/product/': typeof AppProductIndexRoute
  '/profile/': typeof AppProfileIndexRoute
  '/report/': typeof AppReportIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/inventory/category/create': typeof AppInventoryCategoryCreateRoute
  '/inventory/master/create': typeof AppInventoryMasterCreateRoute
  '/inventory/po/create': typeof AppInventoryPoCreateRoute
  '/inventory/uom/create': typeof AppInventoryUomCreateRoute
  '/outlet/device/create': typeof AppOutletDeviceCreateRoute
  '/product/$id/update': typeof AppProductIdUpdateRoute
  '/product/category/create': typeof AppProductCategoryCreateRoute
  '/settings/outlet/$id': typeof AppSettingsOutletIdRoute
  '/settings/outlet/create': typeof AppSettingsOutletCreateRoute
  '/settings/user/create': typeof AppSettingsUserCreateRoute
  '/inventory/category/': typeof AppInventoryCategoryIndexRoute
  '/inventory/master/': typeof AppInventoryMasterIndexRoute
  '/inventory/outlet': typeof AppInventoryOutletIndexRoute
  '/inventory/po/': typeof AppInventoryPoIndexRoute
  '/inventory/recipe/': typeof AppInventoryRecipeIndexRoute
  '/inventory/uom/': typeof AppInventoryUomIndexRoute
  '/outlet/device/': typeof AppOutletDeviceIndexRoute
  '/outlet/staff/': typeof AppOutletStaffIndexRoute
  '/product/category/': typeof AppProductCategoryIndexRoute
  '/settings/outlet/': typeof AppSettingsOutletIndexRoute
  '/settings/user/': typeof AppSettingsUserIndexRoute
  '/inventory/category/update/$id': typeof AppInventoryCategoryUpdateIdRoute
  '/inventory/master/$id/update': typeof AppInventoryMasterIdUpdateRoute
  '/inventory/po/$id/update': typeof AppInventoryPoIdUpdateRoute
  '/outlet/device/$id/update': typeof AppOutletDeviceIdUpdateRoute
  '/product/category/$id/update': typeof AppProductCategoryIdUpdateRoute
  '/settings/user/$id/edit': typeof AppSettingsUserIdEditRoute
  '/inventory/po/$id': typeof AppInventoryPoIdIndexRoute
  '/inventory/uom/update/$id': typeof AppInventoryUomUpdateIdRoute
}
export interface FileRoutesByTo {
  '/auth': typeof AuthRouteRouteWithChildren
  '/logout': typeof LogoutRoute
  '/auth/login': typeof AuthLoginRoute
  '/': typeof AppIndexRoute
  '/block': typeof BlockIndexRoute
  '/product/create': typeof AppProductCreateRoute
  '/report/balance-sheet': typeof AppReportBalanceSheetRoute
  '/report/cash-flow': typeof AppReportCashFlowRoute
  '/report/income-statement': typeof AppReportIncomeStatementRoute
  '/report/journal': typeof AppReportJournalRoute
  '/design': typeof AppDesignIndexRoute
  '/finance': typeof AppFinanceIndexRoute
  '/inventory': typeof AppInventoryIndexRoute
  '/moka': typeof AppMokaIndexRoute
  '/outlet': typeof AppOutletIndexRoute
  '/product': typeof AppProductIndexRoute
  '/profile': typeof AppProfileIndexRoute
  '/report': typeof AppReportIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/inventory/category/create': typeof AppInventoryCategoryCreateRoute
  '/inventory/master/create': typeof AppInventoryMasterCreateRoute
  '/inventory/po/create': typeof AppInventoryPoCreateRoute
  '/inventory/uom/create': typeof AppInventoryUomCreateRoute
  '/outlet/device/create': typeof AppOutletDeviceCreateRoute
  '/product/$id/update': typeof AppProductIdUpdateRoute
  '/product/category/create': typeof AppProductCategoryCreateRoute
  '/settings/outlet/$id': typeof AppSettingsOutletIdRoute
  '/settings/outlet/create': typeof AppSettingsOutletCreateRoute
  '/settings/user/create': typeof AppSettingsUserCreateRoute
  '/inventory/category': typeof AppInventoryCategoryIndexRoute
  '/inventory/master': typeof AppInventoryMasterIndexRoute
  '/inventory/outlet': typeof AppInventoryOutletIndexRoute
  '/inventory/po': typeof AppInventoryPoIndexRoute
  '/inventory/recipe': typeof AppInventoryRecipeIndexRoute
  '/inventory/uom': typeof AppInventoryUomIndexRoute
  '/outlet/device': typeof AppOutletDeviceIndexRoute
  '/outlet/staff': typeof AppOutletStaffIndexRoute
  '/product/category': typeof AppProductCategoryIndexRoute
  '/settings/outlet': typeof AppSettingsOutletIndexRoute
  '/settings/user': typeof AppSettingsUserIndexRoute
  '/inventory/category/update/$id': typeof AppInventoryCategoryUpdateIdRoute
  '/inventory/master/$id/update': typeof AppInventoryMasterIdUpdateRoute
  '/inventory/po/$id/update': typeof AppInventoryPoIdUpdateRoute
  '/outlet/device/$id/update': typeof AppOutletDeviceIdUpdateRoute
  '/product/category/$id/update': typeof AppProductCategoryIdUpdateRoute
  '/settings/user/$id/edit': typeof AppSettingsUserIdEditRoute
  '/inventory/po/$id': typeof AppInventoryPoIdIndexRoute
  '/inventory/uom/update/$id': typeof AppInventoryUomUpdateIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/block': typeof BlockRouteRouteWithChildren
  '/logout': typeof LogoutRoute
  '/_app/design': typeof AppDesignRouteRouteWithChildren
  '/_app/inventory': typeof AppInventoryRouteRouteWithChildren
  '/_app/moka': typeof AppMokaRouteRouteWithChildren
  '/_app/outlet': typeof AppOutletRouteRouteWithChildren
  '/_app/product': typeof AppProductRouteRouteWithChildren
  '/_app/profile': typeof AppProfileRouteRouteWithChildren
  '/_app/report': typeof AppReportRouteRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/_app/': typeof AppIndexRoute
  '/block/': typeof BlockIndexRoute
  '/_app/inventory/category': typeof AppInventoryCategoryRouteRouteWithChildren
  '/_app/inventory/master': typeof AppInventoryMasterRouteRouteWithChildren
  '/_app/inventory/po': typeof AppInventoryPoRouteRouteWithChildren
  '/_app/inventory/recipe': typeof AppInventoryRecipeRouteRouteWithChildren
  '/_app/inventory/uom': typeof AppInventoryUomRouteRouteWithChildren
  '/_app/outlet/device': typeof AppOutletDeviceRouteRouteWithChildren
  '/_app/outlet/staff': typeof AppOutletStaffRouteRouteWithChildren
  '/_app/product/category': typeof AppProductCategoryRouteRouteWithChildren
  '/_app/settings/outlet': typeof AppSettingsOutletRouteRouteWithChildren
  '/_app/settings/user': typeof AppSettingsUserRouteRouteWithChildren
  '/_app/product/create': typeof AppProductCreateRoute
  '/_app/report/balance-sheet': typeof AppReportBalanceSheetRoute
  '/_app/report/cash-flow': typeof AppReportCashFlowRoute
  '/_app/report/income-statement': typeof AppReportIncomeStatementRoute
  '/_app/report/journal': typeof AppReportJournalRoute
  '/_app/design/': typeof AppDesignIndexRoute
  '/_app/finance/': typeof AppFinanceIndexRoute
  '/_app/inventory/': typeof AppInventoryIndexRoute
  '/_app/moka/': typeof AppMokaIndexRoute
  '/_app/outlet/': typeof AppOutletIndexRoute
  '/_app/product/': typeof AppProductIndexRoute
  '/_app/profile/': typeof AppProfileIndexRoute
  '/_app/report/': typeof AppReportIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/inventory/category/create': typeof AppInventoryCategoryCreateRoute
  '/_app/inventory/master/create': typeof AppInventoryMasterCreateRoute
  '/_app/inventory/po/create': typeof AppInventoryPoCreateRoute
  '/_app/inventory/uom/create': typeof AppInventoryUomCreateRoute
  '/_app/outlet/device/create': typeof AppOutletDeviceCreateRoute
  '/_app/product/$id/update': typeof AppProductIdUpdateRoute
  '/_app/product/category/create': typeof AppProductCategoryCreateRoute
  '/_app/settings/outlet/$id': typeof AppSettingsOutletIdRoute
  '/_app/settings/outlet/create': typeof AppSettingsOutletCreateRoute
  '/_app/settings/user/create': typeof AppSettingsUserCreateRoute
  '/_app/inventory/category/': typeof AppInventoryCategoryIndexRoute
  '/_app/inventory/master/': typeof AppInventoryMasterIndexRoute
  '/_app/inventory/outlet/': typeof AppInventoryOutletIndexRoute
  '/_app/inventory/po/': typeof AppInventoryPoIndexRoute
  '/_app/inventory/recipe/': typeof AppInventoryRecipeIndexRoute
  '/_app/inventory/uom/': typeof AppInventoryUomIndexRoute
  '/_app/outlet/device/': typeof AppOutletDeviceIndexRoute
  '/_app/outlet/staff/': typeof AppOutletStaffIndexRoute
  '/_app/product/category/': typeof AppProductCategoryIndexRoute
  '/_app/settings/outlet/': typeof AppSettingsOutletIndexRoute
  '/_app/settings/user/': typeof AppSettingsUserIndexRoute
  '/_app/inventory/category/update/$id': typeof AppInventoryCategoryUpdateIdRoute
  '/_app/inventory/master/$id/update': typeof AppInventoryMasterIdUpdateRoute
  '/_app/inventory/po/$id/update': typeof AppInventoryPoIdUpdateRoute
  '/_app/outlet/device/$id/update': typeof AppOutletDeviceIdUpdateRoute
  '/_app/product/category/$id/update': typeof AppProductCategoryIdUpdateRoute
  '/_app/settings/user/$id/edit': typeof AppSettingsUserIdEditRoute
  '/_app/inventory/po/$id/': typeof AppInventoryPoIdIndexRoute
  '/_app/inventory/uom/update/$id/': typeof AppInventoryUomUpdateIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/auth'
    | '/block'
    | '/logout'
    | '/design'
    | '/inventory'
    | '/moka'
    | '/outlet'
    | '/product'
    | '/profile'
    | '/report'
    | '/settings'
    | '/auth/login'
    | '/'
    | '/block/'
    | '/inventory/category'
    | '/inventory/master'
    | '/inventory/po'
    | '/inventory/recipe'
    | '/inventory/uom'
    | '/outlet/device'
    | '/outlet/staff'
    | '/product/category'
    | '/settings/outlet'
    | '/settings/user'
    | '/product/create'
    | '/report/balance-sheet'
    | '/report/cash-flow'
    | '/report/income-statement'
    | '/report/journal'
    | '/design/'
    | '/finance'
    | '/inventory/'
    | '/moka/'
    | '/outlet/'
    | '/product/'
    | '/profile/'
    | '/report/'
    | '/settings/'
    | '/inventory/category/create'
    | '/inventory/master/create'
    | '/inventory/po/create'
    | '/inventory/uom/create'
    | '/outlet/device/create'
    | '/product/$id/update'
    | '/product/category/create'
    | '/settings/outlet/$id'
    | '/settings/outlet/create'
    | '/settings/user/create'
    | '/inventory/category/'
    | '/inventory/master/'
    | '/inventory/outlet'
    | '/inventory/po/'
    | '/inventory/recipe/'
    | '/inventory/uom/'
    | '/outlet/device/'
    | '/outlet/staff/'
    | '/product/category/'
    | '/settings/outlet/'
    | '/settings/user/'
    | '/inventory/category/update/$id'
    | '/inventory/master/$id/update'
    | '/inventory/po/$id/update'
    | '/outlet/device/$id/update'
    | '/product/category/$id/update'
    | '/settings/user/$id/edit'
    | '/inventory/po/$id'
    | '/inventory/uom/update/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth'
    | '/logout'
    | '/auth/login'
    | '/'
    | '/block'
    | '/product/create'
    | '/report/balance-sheet'
    | '/report/cash-flow'
    | '/report/income-statement'
    | '/report/journal'
    | '/design'
    | '/finance'
    | '/inventory'
    | '/moka'
    | '/outlet'
    | '/product'
    | '/profile'
    | '/report'
    | '/settings'
    | '/inventory/category/create'
    | '/inventory/master/create'
    | '/inventory/po/create'
    | '/inventory/uom/create'
    | '/outlet/device/create'
    | '/product/$id/update'
    | '/product/category/create'
    | '/settings/outlet/$id'
    | '/settings/outlet/create'
    | '/settings/user/create'
    | '/inventory/category'
    | '/inventory/master'
    | '/inventory/outlet'
    | '/inventory/po'
    | '/inventory/recipe'
    | '/inventory/uom'
    | '/outlet/device'
    | '/outlet/staff'
    | '/product/category'
    | '/settings/outlet'
    | '/settings/user'
    | '/inventory/category/update/$id'
    | '/inventory/master/$id/update'
    | '/inventory/po/$id/update'
    | '/outlet/device/$id/update'
    | '/product/category/$id/update'
    | '/settings/user/$id/edit'
    | '/inventory/po/$id'
    | '/inventory/uom/update/$id'
  id:
    | '__root__'
    | '/_app'
    | '/auth'
    | '/block'
    | '/logout'
    | '/_app/design'
    | '/_app/inventory'
    | '/_app/moka'
    | '/_app/outlet'
    | '/_app/product'
    | '/_app/profile'
    | '/_app/report'
    | '/_app/settings'
    | '/auth/login'
    | '/_app/'
    | '/block/'
    | '/_app/inventory/category'
    | '/_app/inventory/master'
    | '/_app/inventory/po'
    | '/_app/inventory/recipe'
    | '/_app/inventory/uom'
    | '/_app/outlet/device'
    | '/_app/outlet/staff'
    | '/_app/product/category'
    | '/_app/settings/outlet'
    | '/_app/settings/user'
    | '/_app/product/create'
    | '/_app/report/balance-sheet'
    | '/_app/report/cash-flow'
    | '/_app/report/income-statement'
    | '/_app/report/journal'
    | '/_app/design/'
    | '/_app/finance/'
    | '/_app/inventory/'
    | '/_app/moka/'
    | '/_app/outlet/'
    | '/_app/product/'
    | '/_app/profile/'
    | '/_app/report/'
    | '/_app/settings/'
    | '/_app/inventory/category/create'
    | '/_app/inventory/master/create'
    | '/_app/inventory/po/create'
    | '/_app/inventory/uom/create'
    | '/_app/outlet/device/create'
    | '/_app/product/$id/update'
    | '/_app/product/category/create'
    | '/_app/settings/outlet/$id'
    | '/_app/settings/outlet/create'
    | '/_app/settings/user/create'
    | '/_app/inventory/category/'
    | '/_app/inventory/master/'
    | '/_app/inventory/outlet/'
    | '/_app/inventory/po/'
    | '/_app/inventory/recipe/'
    | '/_app/inventory/uom/'
    | '/_app/outlet/device/'
    | '/_app/outlet/staff/'
    | '/_app/product/category/'
    | '/_app/settings/outlet/'
    | '/_app/settings/user/'
    | '/_app/inventory/category/update/$id'
    | '/_app/inventory/master/$id/update'
    | '/_app/inventory/po/$id/update'
    | '/_app/outlet/device/$id/update'
    | '/_app/product/category/$id/update'
    | '/_app/settings/user/$id/edit'
    | '/_app/inventory/po/$id/'
    | '/_app/inventory/uom/update/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  BlockRouteRoute: typeof BlockRouteRouteWithChildren
  LogoutRoute: typeof LogoutRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/block': {
      id: '/block'
      path: '/block'
      fullPath: '/block'
      preLoaderRoute: typeof BlockRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/block/': {
      id: '/block/'
      path: '/'
      fullPath: '/block/'
      preLoaderRoute: typeof BlockIndexRouteImport
      parentRoute: typeof BlockRouteRoute
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/report': {
      id: '/_app/report'
      path: '/report'
      fullPath: '/report'
      preLoaderRoute: typeof AppReportRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/product': {
      id: '/_app/product'
      path: '/product'
      fullPath: '/product'
      preLoaderRoute: typeof AppProductRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/outlet': {
      id: '/_app/outlet'
      path: '/outlet'
      fullPath: '/outlet'
      preLoaderRoute: typeof AppOutletRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/moka': {
      id: '/_app/moka'
      path: '/moka'
      fullPath: '/moka'
      preLoaderRoute: typeof AppMokaRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/inventory': {
      id: '/_app/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof AppInventoryRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/design': {
      id: '/_app/design'
      path: '/design'
      fullPath: '/design'
      preLoaderRoute: typeof AppDesignRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/report/': {
      id: '/_app/report/'
      path: '/'
      fullPath: '/report/'
      preLoaderRoute: typeof AppReportIndexRouteImport
      parentRoute: typeof AppReportRouteRoute
    }
    '/_app/profile/': {
      id: '/_app/profile/'
      path: '/'
      fullPath: '/profile/'
      preLoaderRoute: typeof AppProfileIndexRouteImport
      parentRoute: typeof AppProfileRouteRoute
    }
    '/_app/product/': {
      id: '/_app/product/'
      path: '/'
      fullPath: '/product/'
      preLoaderRoute: typeof AppProductIndexRouteImport
      parentRoute: typeof AppProductRouteRoute
    }
    '/_app/outlet/': {
      id: '/_app/outlet/'
      path: '/'
      fullPath: '/outlet/'
      preLoaderRoute: typeof AppOutletIndexRouteImport
      parentRoute: typeof AppOutletRouteRoute
    }
    '/_app/moka/': {
      id: '/_app/moka/'
      path: '/'
      fullPath: '/moka/'
      preLoaderRoute: typeof AppMokaIndexRouteImport
      parentRoute: typeof AppMokaRouteRoute
    }
    '/_app/inventory/': {
      id: '/_app/inventory/'
      path: '/'
      fullPath: '/inventory/'
      preLoaderRoute: typeof AppInventoryIndexRouteImport
      parentRoute: typeof AppInventoryRouteRoute
    }
    '/_app/finance/': {
      id: '/_app/finance/'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof AppFinanceIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/design/': {
      id: '/_app/design/'
      path: '/'
      fullPath: '/design/'
      preLoaderRoute: typeof AppDesignIndexRouteImport
      parentRoute: typeof AppDesignRouteRoute
    }
    '/_app/report/journal': {
      id: '/_app/report/journal'
      path: '/journal'
      fullPath: '/report/journal'
      preLoaderRoute: typeof AppReportJournalRouteImport
      parentRoute: typeof AppReportRouteRoute
    }
    '/_app/report/income-statement': {
      id: '/_app/report/income-statement'
      path: '/income-statement'
      fullPath: '/report/income-statement'
      preLoaderRoute: typeof AppReportIncomeStatementRouteImport
      parentRoute: typeof AppReportRouteRoute
    }
    '/_app/report/cash-flow': {
      id: '/_app/report/cash-flow'
      path: '/cash-flow'
      fullPath: '/report/cash-flow'
      preLoaderRoute: typeof AppReportCashFlowRouteImport
      parentRoute: typeof AppReportRouteRoute
    }
    '/_app/report/balance-sheet': {
      id: '/_app/report/balance-sheet'
      path: '/balance-sheet'
      fullPath: '/report/balance-sheet'
      preLoaderRoute: typeof AppReportBalanceSheetRouteImport
      parentRoute: typeof AppReportRouteRoute
    }
    '/_app/product/create': {
      id: '/_app/product/create'
      path: '/create'
      fullPath: '/product/create'
      preLoaderRoute: typeof AppProductCreateRouteImport
      parentRoute: typeof AppProductRouteRoute
    }
    '/_app/settings/user': {
      id: '/_app/settings/user'
      path: '/user'
      fullPath: '/settings/user'
      preLoaderRoute: typeof AppSettingsUserRouteRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/outlet': {
      id: '/_app/settings/outlet'
      path: '/outlet'
      fullPath: '/settings/outlet'
      preLoaderRoute: typeof AppSettingsOutletRouteRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/product/category': {
      id: '/_app/product/category'
      path: '/category'
      fullPath: '/product/category'
      preLoaderRoute: typeof AppProductCategoryRouteRouteImport
      parentRoute: typeof AppProductRouteRoute
    }
    '/_app/outlet/staff': {
      id: '/_app/outlet/staff'
      path: '/staff'
      fullPath: '/outlet/staff'
      preLoaderRoute: typeof AppOutletStaffRouteRouteImport
      parentRoute: typeof AppOutletRouteRoute
    }
    '/_app/outlet/device': {
      id: '/_app/outlet/device'
      path: '/device'
      fullPath: '/outlet/device'
      preLoaderRoute: typeof AppOutletDeviceRouteRouteImport
      parentRoute: typeof AppOutletRouteRoute
    }
    '/_app/inventory/uom': {
      id: '/_app/inventory/uom'
      path: '/uom'
      fullPath: '/inventory/uom'
      preLoaderRoute: typeof AppInventoryUomRouteRouteImport
      parentRoute: typeof AppInventoryRouteRoute
    }
    '/_app/inventory/recipe': {
      id: '/_app/inventory/recipe'
      path: '/recipe'
      fullPath: '/inventory/recipe'
      preLoaderRoute: typeof AppInventoryRecipeRouteRouteImport
      parentRoute: typeof AppInventoryRouteRoute
    }
    '/_app/inventory/po': {
      id: '/_app/inventory/po'
      path: '/po'
      fullPath: '/inventory/po'
      preLoaderRoute: typeof AppInventoryPoRouteRouteImport
      parentRoute: typeof AppInventoryRouteRoute
    }
    '/_app/inventory/master': {
      id: '/_app/inventory/master'
      path: '/master'
      fullPath: '/inventory/master'
      preLoaderRoute: typeof AppInventoryMasterRouteRouteImport
      parentRoute: typeof AppInventoryRouteRoute
    }
    '/_app/inventory/category': {
      id: '/_app/inventory/category'
      path: '/category'
      fullPath: '/inventory/category'
      preLoaderRoute: typeof AppInventoryCategoryRouteRouteImport
      parentRoute: typeof AppInventoryRouteRoute
    }
    '/_app/settings/user/': {
      id: '/_app/settings/user/'
      path: '/'
      fullPath: '/settings/user/'
      preLoaderRoute: typeof AppSettingsUserIndexRouteImport
      parentRoute: typeof AppSettingsUserRouteRoute
    }
    '/_app/settings/outlet/': {
      id: '/_app/settings/outlet/'
      path: '/'
      fullPath: '/settings/outlet/'
      preLoaderRoute: typeof AppSettingsOutletIndexRouteImport
      parentRoute: typeof AppSettingsOutletRouteRoute
    }
    '/_app/product/category/': {
      id: '/_app/product/category/'
      path: '/'
      fullPath: '/product/category/'
      preLoaderRoute: typeof AppProductCategoryIndexRouteImport
      parentRoute: typeof AppProductCategoryRouteRoute
    }
    '/_app/outlet/staff/': {
      id: '/_app/outlet/staff/'
      path: '/'
      fullPath: '/outlet/staff/'
      preLoaderRoute: typeof AppOutletStaffIndexRouteImport
      parentRoute: typeof AppOutletStaffRouteRoute
    }
    '/_app/outlet/device/': {
      id: '/_app/outlet/device/'
      path: '/'
      fullPath: '/outlet/device/'
      preLoaderRoute: typeof AppOutletDeviceIndexRouteImport
      parentRoute: typeof AppOutletDeviceRouteRoute
    }
    '/_app/inventory/uom/': {
      id: '/_app/inventory/uom/'
      path: '/'
      fullPath: '/inventory/uom/'
      preLoaderRoute: typeof AppInventoryUomIndexRouteImport
      parentRoute: typeof AppInventoryUomRouteRoute
    }
    '/_app/inventory/recipe/': {
      id: '/_app/inventory/recipe/'
      path: '/'
      fullPath: '/inventory/recipe/'
      preLoaderRoute: typeof AppInventoryRecipeIndexRouteImport
      parentRoute: typeof AppInventoryRecipeRouteRoute
    }
    '/_app/inventory/po/': {
      id: '/_app/inventory/po/'
      path: '/'
      fullPath: '/inventory/po/'
      preLoaderRoute: typeof AppInventoryPoIndexRouteImport
      parentRoute: typeof AppInventoryPoRouteRoute
    }
    '/_app/inventory/outlet/': {
      id: '/_app/inventory/outlet/'
      path: '/outlet'
      fullPath: '/inventory/outlet'
      preLoaderRoute: typeof AppInventoryOutletIndexRouteImport
      parentRoute: typeof AppInventoryRouteRoute
    }
    '/_app/inventory/master/': {
      id: '/_app/inventory/master/'
      path: '/'
      fullPath: '/inventory/master/'
      preLoaderRoute: typeof AppInventoryMasterIndexRouteImport
      parentRoute: typeof AppInventoryMasterRouteRoute
    }
    '/_app/inventory/category/': {
      id: '/_app/inventory/category/'
      path: '/'
      fullPath: '/inventory/category/'
      preLoaderRoute: typeof AppInventoryCategoryIndexRouteImport
      parentRoute: typeof AppInventoryCategoryRouteRoute
    }
    '/_app/settings/user/create': {
      id: '/_app/settings/user/create'
      path: '/create'
      fullPath: '/settings/user/create'
      preLoaderRoute: typeof AppSettingsUserCreateRouteImport
      parentRoute: typeof AppSettingsUserRouteRoute
    }
    '/_app/settings/outlet/create': {
      id: '/_app/settings/outlet/create'
      path: '/create'
      fullPath: '/settings/outlet/create'
      preLoaderRoute: typeof AppSettingsOutletCreateRouteImport
      parentRoute: typeof AppSettingsOutletRouteRoute
    }
    '/_app/settings/outlet/$id': {
      id: '/_app/settings/outlet/$id'
      path: '/$id'
      fullPath: '/settings/outlet/$id'
      preLoaderRoute: typeof AppSettingsOutletIdRouteImport
      parentRoute: typeof AppSettingsOutletRouteRoute
    }
    '/_app/product/category/create': {
      id: '/_app/product/category/create'
      path: '/create'
      fullPath: '/product/category/create'
      preLoaderRoute: typeof AppProductCategoryCreateRouteImport
      parentRoute: typeof AppProductCategoryRouteRoute
    }
    '/_app/product/$id/update': {
      id: '/_app/product/$id/update'
      path: '/$id/update'
      fullPath: '/product/$id/update'
      preLoaderRoute: typeof AppProductIdUpdateRouteImport
      parentRoute: typeof AppProductRouteRoute
    }
    '/_app/outlet/device/create': {
      id: '/_app/outlet/device/create'
      path: '/create'
      fullPath: '/outlet/device/create'
      preLoaderRoute: typeof AppOutletDeviceCreateRouteImport
      parentRoute: typeof AppOutletDeviceRouteRoute
    }
    '/_app/inventory/uom/create': {
      id: '/_app/inventory/uom/create'
      path: '/create'
      fullPath: '/inventory/uom/create'
      preLoaderRoute: typeof AppInventoryUomCreateRouteImport
      parentRoute: typeof AppInventoryUomRouteRoute
    }
    '/_app/inventory/po/create': {
      id: '/_app/inventory/po/create'
      path: '/create'
      fullPath: '/inventory/po/create'
      preLoaderRoute: typeof AppInventoryPoCreateRouteImport
      parentRoute: typeof AppInventoryPoRouteRoute
    }
    '/_app/inventory/master/create': {
      id: '/_app/inventory/master/create'
      path: '/create'
      fullPath: '/inventory/master/create'
      preLoaderRoute: typeof AppInventoryMasterCreateRouteImport
      parentRoute: typeof AppInventoryMasterRouteRoute
    }
    '/_app/inventory/category/create': {
      id: '/_app/inventory/category/create'
      path: '/create'
      fullPath: '/inventory/category/create'
      preLoaderRoute: typeof AppInventoryCategoryCreateRouteImport
      parentRoute: typeof AppInventoryCategoryRouteRoute
    }
    '/_app/inventory/po/$id/': {
      id: '/_app/inventory/po/$id/'
      path: '/$id'
      fullPath: '/inventory/po/$id'
      preLoaderRoute: typeof AppInventoryPoIdIndexRouteImport
      parentRoute: typeof AppInventoryPoRouteRoute
    }
    '/_app/settings/user/$id/edit': {
      id: '/_app/settings/user/$id/edit'
      path: '/$id/edit'
      fullPath: '/settings/user/$id/edit'
      preLoaderRoute: typeof AppSettingsUserIdEditRouteImport
      parentRoute: typeof AppSettingsUserRouteRoute
    }
    '/_app/product/category/$id/update': {
      id: '/_app/product/category/$id/update'
      path: '/$id/update'
      fullPath: '/product/category/$id/update'
      preLoaderRoute: typeof AppProductCategoryIdUpdateRouteImport
      parentRoute: typeof AppProductCategoryRouteRoute
    }
    '/_app/outlet/device/$id/update': {
      id: '/_app/outlet/device/$id/update'
      path: '/$id/update'
      fullPath: '/outlet/device/$id/update'
      preLoaderRoute: typeof AppOutletDeviceIdUpdateRouteImport
      parentRoute: typeof AppOutletDeviceRouteRoute
    }
    '/_app/inventory/po/$id/update': {
      id: '/_app/inventory/po/$id/update'
      path: '/$id/update'
      fullPath: '/inventory/po/$id/update'
      preLoaderRoute: typeof AppInventoryPoIdUpdateRouteImport
      parentRoute: typeof AppInventoryPoRouteRoute
    }
    '/_app/inventory/master/$id/update': {
      id: '/_app/inventory/master/$id/update'
      path: '/$id/update'
      fullPath: '/inventory/master/$id/update'
      preLoaderRoute: typeof AppInventoryMasterIdUpdateRouteImport
      parentRoute: typeof AppInventoryMasterRouteRoute
    }
    '/_app/inventory/category/update/$id': {
      id: '/_app/inventory/category/update/$id'
      path: '/update/$id'
      fullPath: '/inventory/category/update/$id'
      preLoaderRoute: typeof AppInventoryCategoryUpdateIdRouteImport
      parentRoute: typeof AppInventoryCategoryRouteRoute
    }
    '/_app/inventory/uom/update/$id/': {
      id: '/_app/inventory/uom/update/$id/'
      path: '/update/$id'
      fullPath: '/inventory/uom/update/$id'
      preLoaderRoute: typeof AppInventoryUomUpdateIdRouteImport
      parentRoute: typeof AppInventoryUomRouteRoute
    }
  }
}

interface AppDesignRouteRouteChildren {
  AppDesignIndexRoute: typeof AppDesignIndexRoute
}

const AppDesignRouteRouteChildren: AppDesignRouteRouteChildren = {
  AppDesignIndexRoute: AppDesignIndexRoute,
}

const AppDesignRouteRouteWithChildren = AppDesignRouteRoute._addFileChildren(
  AppDesignRouteRouteChildren,
)

interface AppInventoryCategoryRouteRouteChildren {
  AppInventoryCategoryCreateRoute: typeof AppInventoryCategoryCreateRoute
  AppInventoryCategoryIndexRoute: typeof AppInventoryCategoryIndexRoute
  AppInventoryCategoryUpdateIdRoute: typeof AppInventoryCategoryUpdateIdRoute
}

const AppInventoryCategoryRouteRouteChildren: AppInventoryCategoryRouteRouteChildren =
  {
    AppInventoryCategoryCreateRoute: AppInventoryCategoryCreateRoute,
    AppInventoryCategoryIndexRoute: AppInventoryCategoryIndexRoute,
    AppInventoryCategoryUpdateIdRoute: AppInventoryCategoryUpdateIdRoute,
  }

const AppInventoryCategoryRouteRouteWithChildren =
  AppInventoryCategoryRouteRoute._addFileChildren(
    AppInventoryCategoryRouteRouteChildren,
  )

interface AppInventoryMasterRouteRouteChildren {
  AppInventoryMasterCreateRoute: typeof AppInventoryMasterCreateRoute
  AppInventoryMasterIndexRoute: typeof AppInventoryMasterIndexRoute
  AppInventoryMasterIdUpdateRoute: typeof AppInventoryMasterIdUpdateRoute
}

const AppInventoryMasterRouteRouteChildren: AppInventoryMasterRouteRouteChildren =
  {
    AppInventoryMasterCreateRoute: AppInventoryMasterCreateRoute,
    AppInventoryMasterIndexRoute: AppInventoryMasterIndexRoute,
    AppInventoryMasterIdUpdateRoute: AppInventoryMasterIdUpdateRoute,
  }

const AppInventoryMasterRouteRouteWithChildren =
  AppInventoryMasterRouteRoute._addFileChildren(
    AppInventoryMasterRouteRouteChildren,
  )

interface AppInventoryPoRouteRouteChildren {
  AppInventoryPoCreateRoute: typeof AppInventoryPoCreateRoute
  AppInventoryPoIndexRoute: typeof AppInventoryPoIndexRoute
  AppInventoryPoIdUpdateRoute: typeof AppInventoryPoIdUpdateRoute
  AppInventoryPoIdIndexRoute: typeof AppInventoryPoIdIndexRoute
}

const AppInventoryPoRouteRouteChildren: AppInventoryPoRouteRouteChildren = {
  AppInventoryPoCreateRoute: AppInventoryPoCreateRoute,
  AppInventoryPoIndexRoute: AppInventoryPoIndexRoute,
  AppInventoryPoIdUpdateRoute: AppInventoryPoIdUpdateRoute,
  AppInventoryPoIdIndexRoute: AppInventoryPoIdIndexRoute,
}

const AppInventoryPoRouteRouteWithChildren =
  AppInventoryPoRouteRoute._addFileChildren(AppInventoryPoRouteRouteChildren)

interface AppInventoryRecipeRouteRouteChildren {
  AppInventoryRecipeIndexRoute: typeof AppInventoryRecipeIndexRoute
}

const AppInventoryRecipeRouteRouteChildren: AppInventoryRecipeRouteRouteChildren =
  {
    AppInventoryRecipeIndexRoute: AppInventoryRecipeIndexRoute,
  }

const AppInventoryRecipeRouteRouteWithChildren =
  AppInventoryRecipeRouteRoute._addFileChildren(
    AppInventoryRecipeRouteRouteChildren,
  )

interface AppInventoryUomRouteRouteChildren {
  AppInventoryUomCreateRoute: typeof AppInventoryUomCreateRoute
  AppInventoryUomIndexRoute: typeof AppInventoryUomIndexRoute
  AppInventoryUomUpdateIdRoute: typeof AppInventoryUomUpdateIdRoute
}

const AppInventoryUomRouteRouteChildren: AppInventoryUomRouteRouteChildren = {
  AppInventoryUomCreateRoute: AppInventoryUomCreateRoute,
  AppInventoryUomIndexRoute: AppInventoryUomIndexRoute,
  AppInventoryUomUpdateIdRoute: AppInventoryUomUpdateIdRoute,
}

const AppInventoryUomRouteRouteWithChildren =
  AppInventoryUomRouteRoute._addFileChildren(AppInventoryUomRouteRouteChildren)

interface AppInventoryRouteRouteChildren {
  AppInventoryCategoryRouteRoute: typeof AppInventoryCategoryRouteRouteWithChildren
  AppInventoryMasterRouteRoute: typeof AppInventoryMasterRouteRouteWithChildren
  AppInventoryPoRouteRoute: typeof AppInventoryPoRouteRouteWithChildren
  AppInventoryRecipeRouteRoute: typeof AppInventoryRecipeRouteRouteWithChildren
  AppInventoryUomRouteRoute: typeof AppInventoryUomRouteRouteWithChildren
  AppInventoryIndexRoute: typeof AppInventoryIndexRoute
  AppInventoryOutletIndexRoute: typeof AppInventoryOutletIndexRoute
}

const AppInventoryRouteRouteChildren: AppInventoryRouteRouteChildren = {
  AppInventoryCategoryRouteRoute: AppInventoryCategoryRouteRouteWithChildren,
  AppInventoryMasterRouteRoute: AppInventoryMasterRouteRouteWithChildren,
  AppInventoryPoRouteRoute: AppInventoryPoRouteRouteWithChildren,
  AppInventoryRecipeRouteRoute: AppInventoryRecipeRouteRouteWithChildren,
  AppInventoryUomRouteRoute: AppInventoryUomRouteRouteWithChildren,
  AppInventoryIndexRoute: AppInventoryIndexRoute,
  AppInventoryOutletIndexRoute: AppInventoryOutletIndexRoute,
}

const AppInventoryRouteRouteWithChildren =
  AppInventoryRouteRoute._addFileChildren(AppInventoryRouteRouteChildren)

interface AppMokaRouteRouteChildren {
  AppMokaIndexRoute: typeof AppMokaIndexRoute
}

const AppMokaRouteRouteChildren: AppMokaRouteRouteChildren = {
  AppMokaIndexRoute: AppMokaIndexRoute,
}

const AppMokaRouteRouteWithChildren = AppMokaRouteRoute._addFileChildren(
  AppMokaRouteRouteChildren,
)

interface AppOutletDeviceRouteRouteChildren {
  AppOutletDeviceCreateRoute: typeof AppOutletDeviceCreateRoute
  AppOutletDeviceIndexRoute: typeof AppOutletDeviceIndexRoute
  AppOutletDeviceIdUpdateRoute: typeof AppOutletDeviceIdUpdateRoute
}

const AppOutletDeviceRouteRouteChildren: AppOutletDeviceRouteRouteChildren = {
  AppOutletDeviceCreateRoute: AppOutletDeviceCreateRoute,
  AppOutletDeviceIndexRoute: AppOutletDeviceIndexRoute,
  AppOutletDeviceIdUpdateRoute: AppOutletDeviceIdUpdateRoute,
}

const AppOutletDeviceRouteRouteWithChildren =
  AppOutletDeviceRouteRoute._addFileChildren(AppOutletDeviceRouteRouteChildren)

interface AppOutletStaffRouteRouteChildren {
  AppOutletStaffIndexRoute: typeof AppOutletStaffIndexRoute
}

const AppOutletStaffRouteRouteChildren: AppOutletStaffRouteRouteChildren = {
  AppOutletStaffIndexRoute: AppOutletStaffIndexRoute,
}

const AppOutletStaffRouteRouteWithChildren =
  AppOutletStaffRouteRoute._addFileChildren(AppOutletStaffRouteRouteChildren)

interface AppOutletRouteRouteChildren {
  AppOutletDeviceRouteRoute: typeof AppOutletDeviceRouteRouteWithChildren
  AppOutletStaffRouteRoute: typeof AppOutletStaffRouteRouteWithChildren
  AppOutletIndexRoute: typeof AppOutletIndexRoute
}

const AppOutletRouteRouteChildren: AppOutletRouteRouteChildren = {
  AppOutletDeviceRouteRoute: AppOutletDeviceRouteRouteWithChildren,
  AppOutletStaffRouteRoute: AppOutletStaffRouteRouteWithChildren,
  AppOutletIndexRoute: AppOutletIndexRoute,
}

const AppOutletRouteRouteWithChildren = AppOutletRouteRoute._addFileChildren(
  AppOutletRouteRouteChildren,
)

interface AppProductCategoryRouteRouteChildren {
  AppProductCategoryCreateRoute: typeof AppProductCategoryCreateRoute
  AppProductCategoryIndexRoute: typeof AppProductCategoryIndexRoute
  AppProductCategoryIdUpdateRoute: typeof AppProductCategoryIdUpdateRoute
}

const AppProductCategoryRouteRouteChildren: AppProductCategoryRouteRouteChildren =
  {
    AppProductCategoryCreateRoute: AppProductCategoryCreateRoute,
    AppProductCategoryIndexRoute: AppProductCategoryIndexRoute,
    AppProductCategoryIdUpdateRoute: AppProductCategoryIdUpdateRoute,
  }

const AppProductCategoryRouteRouteWithChildren =
  AppProductCategoryRouteRoute._addFileChildren(
    AppProductCategoryRouteRouteChildren,
  )

interface AppProductRouteRouteChildren {
  AppProductCategoryRouteRoute: typeof AppProductCategoryRouteRouteWithChildren
  AppProductCreateRoute: typeof AppProductCreateRoute
  AppProductIndexRoute: typeof AppProductIndexRoute
  AppProductIdUpdateRoute: typeof AppProductIdUpdateRoute
}

const AppProductRouteRouteChildren: AppProductRouteRouteChildren = {
  AppProductCategoryRouteRoute: AppProductCategoryRouteRouteWithChildren,
  AppProductCreateRoute: AppProductCreateRoute,
  AppProductIndexRoute: AppProductIndexRoute,
  AppProductIdUpdateRoute: AppProductIdUpdateRoute,
}

const AppProductRouteRouteWithChildren = AppProductRouteRoute._addFileChildren(
  AppProductRouteRouteChildren,
)

interface AppProfileRouteRouteChildren {
  AppProfileIndexRoute: typeof AppProfileIndexRoute
}

const AppProfileRouteRouteChildren: AppProfileRouteRouteChildren = {
  AppProfileIndexRoute: AppProfileIndexRoute,
}

const AppProfileRouteRouteWithChildren = AppProfileRouteRoute._addFileChildren(
  AppProfileRouteRouteChildren,
)

interface AppReportRouteRouteChildren {
  AppReportBalanceSheetRoute: typeof AppReportBalanceSheetRoute
  AppReportCashFlowRoute: typeof AppReportCashFlowRoute
  AppReportIncomeStatementRoute: typeof AppReportIncomeStatementRoute
  AppReportJournalRoute: typeof AppReportJournalRoute
  AppReportIndexRoute: typeof AppReportIndexRoute
}

const AppReportRouteRouteChildren: AppReportRouteRouteChildren = {
  AppReportBalanceSheetRoute: AppReportBalanceSheetRoute,
  AppReportCashFlowRoute: AppReportCashFlowRoute,
  AppReportIncomeStatementRoute: AppReportIncomeStatementRoute,
  AppReportJournalRoute: AppReportJournalRoute,
  AppReportIndexRoute: AppReportIndexRoute,
}

const AppReportRouteRouteWithChildren = AppReportRouteRoute._addFileChildren(
  AppReportRouteRouteChildren,
)

interface AppSettingsOutletRouteRouteChildren {
  AppSettingsOutletIdRoute: typeof AppSettingsOutletIdRoute
  AppSettingsOutletCreateRoute: typeof AppSettingsOutletCreateRoute
  AppSettingsOutletIndexRoute: typeof AppSettingsOutletIndexRoute
}

const AppSettingsOutletRouteRouteChildren: AppSettingsOutletRouteRouteChildren =
  {
    AppSettingsOutletIdRoute: AppSettingsOutletIdRoute,
    AppSettingsOutletCreateRoute: AppSettingsOutletCreateRoute,
    AppSettingsOutletIndexRoute: AppSettingsOutletIndexRoute,
  }

const AppSettingsOutletRouteRouteWithChildren =
  AppSettingsOutletRouteRoute._addFileChildren(
    AppSettingsOutletRouteRouteChildren,
  )

interface AppSettingsUserRouteRouteChildren {
  AppSettingsUserCreateRoute: typeof AppSettingsUserCreateRoute
  AppSettingsUserIndexRoute: typeof AppSettingsUserIndexRoute
  AppSettingsUserIdEditRoute: typeof AppSettingsUserIdEditRoute
}

const AppSettingsUserRouteRouteChildren: AppSettingsUserRouteRouteChildren = {
  AppSettingsUserCreateRoute: AppSettingsUserCreateRoute,
  AppSettingsUserIndexRoute: AppSettingsUserIndexRoute,
  AppSettingsUserIdEditRoute: AppSettingsUserIdEditRoute,
}

const AppSettingsUserRouteRouteWithChildren =
  AppSettingsUserRouteRoute._addFileChildren(AppSettingsUserRouteRouteChildren)

interface AppSettingsRouteRouteChildren {
  AppSettingsOutletRouteRoute: typeof AppSettingsOutletRouteRouteWithChildren
  AppSettingsUserRouteRoute: typeof AppSettingsUserRouteRouteWithChildren
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsOutletRouteRoute: AppSettingsOutletRouteRouteWithChildren,
  AppSettingsUserRouteRoute: AppSettingsUserRouteRouteWithChildren,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppRouteRouteChildren {
  AppDesignRouteRoute: typeof AppDesignRouteRouteWithChildren
  AppInventoryRouteRoute: typeof AppInventoryRouteRouteWithChildren
  AppMokaRouteRoute: typeof AppMokaRouteRouteWithChildren
  AppOutletRouteRoute: typeof AppOutletRouteRouteWithChildren
  AppProductRouteRoute: typeof AppProductRouteRouteWithChildren
  AppProfileRouteRoute: typeof AppProfileRouteRouteWithChildren
  AppReportRouteRoute: typeof AppReportRouteRouteWithChildren
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppFinanceIndexRoute: typeof AppFinanceIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppDesignRouteRoute: AppDesignRouteRouteWithChildren,
  AppInventoryRouteRoute: AppInventoryRouteRouteWithChildren,
  AppMokaRouteRoute: AppMokaRouteRouteWithChildren,
  AppOutletRouteRoute: AppOutletRouteRouteWithChildren,
  AppProductRouteRoute: AppProductRouteRouteWithChildren,
  AppProfileRouteRoute: AppProfileRouteRouteWithChildren,
  AppReportRouteRoute: AppReportRouteRouteWithChildren,
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppFinanceIndexRoute: AppFinanceIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface BlockRouteRouteChildren {
  BlockIndexRoute: typeof BlockIndexRoute
}

const BlockRouteRouteChildren: BlockRouteRouteChildren = {
  BlockIndexRoute: BlockIndexRoute,
}

const BlockRouteRouteWithChildren = BlockRouteRoute._addFileChildren(
  BlockRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  BlockRouteRoute: BlockRouteRouteWithChildren,
  LogoutRoute: LogoutRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
